import { anim, pv, stagger } from '../../../../motion'
import { Shape } from '../../../../primitives'
import { Fit, Line } from '../../../../v2/kit'
import { useCopy } from '../../../i18n'
import { MaskText } from '../../stage/fx'

export const PERSPECTIVE_PARTICLES = [
  [0.05, () => ({ type: 'scatter', alpha: 0.18, seed: 29 })],
  [0.95, () => ({ type: 'scatter', alpha: 0.18, seed: 31 })]
]

const LOOK = [
  { kind: 'sq', color: 'blue', tone: '#407BFF' },
  { kind: 'dot', color: 'green', tone: '#43DBBD' },
  { kind: 'tri', color: 'yellow', tone: '#FFB628' },
  { kind: 'sq', color: 'pink', tone: '#FE79A7' }
]

// Drei Vierteldrehungen, jede in ihrem eigenen Fenster, dazwischen steht das Prisma
const TURNS = [
  [0.26, 0.36],
  [0.46, 0.56],
  [0.66, 0.76]
]
const FACE = (i) => [
  i === 0 ? -1 : TURNS[i - 1][1] - 0.04,
  i === 3 ? 2 : TURNS[i][0] + 0.04
]

const NARROW = { maxW: 0.86, maxH: 0.5 }

export default function DmsPerspectives() {
  const c = useCopy('perspektiven')

  return (
    <div className='sc-full'>
      <div className='dms-persp-head'>
        <Line at={[0, 0.05]} className='sc-eyebrow'>
          {c.eyebrow}
        </Line>
        <h2 className='sc-h2'>
          <MaskText text={c.title} at={[0.02, 0.1]} />
        </h2>
        <Line at={[0.08, 0.14]} y={20} className='sc-lead dms-persp-sub'>
          {c.sub}
        </Line>
        <ol className='dms-persp-index'>
          {c.groups.map((g, i) => (
            <li
              key={g.title}
              style={{
                ...pv('a', [FACE(i)[0], FACE(i)[0] + 0.02]),
                ...pv('b', [FACE(i)[1], FACE(i)[1] + 0.02]),
                '--tone': LOOK[i].tone
              }}
            >
              {g.title}
            </li>
          ))}
        </ol>
      </div>

      <Fit
        w={560}
        h={420}
        maxW={0.5}
        maxH={0.62}
        narrow={NARROW}
        className='dms-prism-fit'
      >
        <div
          className='dms-prism'
          style={{
            ...anim({ at: [0.1, 0.2], y: 120, s: 0.8 }),
            ...pv('r', TURNS[0]),
            ...pv('s', TURNS[1]),
            ...pv('t', TURNS[2])
          }}
        >
          <div className='dms-prism__spin'>
            {c.groups.map((g, i) => (
              <article
                key={g.title}
                className='dms-face'
                style={{ '--i': i, '--tone': LOOK[i].tone }}
              >
                <div className='dms-face__top'>
                  <Shape kind={LOOK[i].kind} color={LOOK[i].color} size={34} />
                  <span>{g.tag}</span>
                </div>
                <h3 className='sc-h3'>{g.title}</h3>
                <p className='dms-face__q'>{g.question}</p>
                <div className='dms-face__items'>
                  {g.items.map((item, j) => (
                    <span
                      key={item}
                      style={anim({
                        at: stagger(FACE(i)[0] + 0.03, 0.01, 0.04, j),
                        y: 14,
                        s: 0.8
                      })}
                    >
                      {item}
                    </span>
                  ))}
                </div>
              </article>
            ))}
          </div>
        </div>
      </Fit>
    </div>
  )
}
